import { useEffect } from 'react'

import { $getNodeByKey, $isParagraphNode } from 'lexical'

import { KeySet } from '@eastcoal/common/types/utilities'
import { pick } from '@eastcoal/common/utils/object'

import { useEditor } from '../../../hooks/useEditor'
import { useSelectAndRemove } from '../../../hooks/useSelectAndRemove'
import { useSyncNodeState } from '../../../hooks/useSyncNodeState'
import { $isImageNode } from '../../../nodes/ImageNode'
import {
  useImageCardStore,
  useImageCardStoreApi
} from '../Store/hooks/useStore'
import { ImageCardSyncState } from '../Store/store/interface'

/**
 * ImageCard 需要持久化的状态键集合
 */
const IMAGE_CARD_SYNC_STATE_KEYS: KeySet<ImageCardSyncState>[] = [
  'ossId',
  'ossUrl',
  'filename',
  'error',
  'rotate',
  'align',
  'bordered',
  'shadowed',
  'link',
  'desc',
  'descInputVisible',
  'currentWidth',
  'currentHeight'
]

export const ImageSynchorizner = () => {
  const { nodeKey, containerRef, align } = useImageCardStore(state =>
    pick(state, ['nodeKey', 'containerRef', 'align'])
  )
  const { subscribe } = useImageCardStoreApi()

  const editor = useEditor()

  // 选中/删除
  useSelectAndRemove({
    nodeKey,
    containerRef: containerRef,
    allowRemove: $isImageNode
  })

  // 同步对齐方式
  useEffect(() => {
    if (align) {
      editor.update(() => {
        const node = $getNodeByKey(nodeKey)
        if (!$isImageNode(node)) {
          return
        }
        const parentNode = node.getParentOrThrow()
        if (!$isParagraphNode(parentNode)) {
          return
        }
        parentNode.setFormat(align)
      })
    }
  }, [editor, nodeKey, align])

  // ImageCard => ImageNode 状态同步
  useSyncNodeState({
    nodeKey,
    stateKeys: IMAGE_CARD_SYNC_STATE_KEYS,
    isTargetNode: $isImageNode,
    subscribe
  })

  return null
}
